import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { ButtonLink } from '@yme/molecules/buttons';
export const LinkStyled = styled(Link) `
  text-decoration: none;
`;
export const ButtonLinkStyled = styled(ButtonLink) `
  display: inline-block;
  margin-top: 24px;
`;
